<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      {{ `${this.user.first_name} ${this.user.last_name}` }}
      <img
        src="img/avatars/6.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item><i class="fa fa-user" /> Profile</b-dropdown-item>
      <b-dropdown-item>
        <router-link to="/configurations/system-settings">
          <i class="fa fa-wrench" /> Settings
        </router-link>
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { baseURL } from '../shared/utils';
import { mapState } from 'vuex';

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data() {
    return { itemsCount: 42 }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  methods: {
    logout() {
      try {
        localStorage.removeItem('user')
        localStorage.removeItem('jwt')
        this.$router.push('/login')
      } catch(err) {
        console.log(err)
      }
    }
  }
}
</script>
